import React, { useState,useEffect } from "react";
import ShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import "./style.css";
import anime from "animejs/lib/anime.es.js";
export default function ProductCard({
  index,
  famille,
  article,
  categorie,
  subcategorie,
  subSubcategorie,
  prixPromo,
  prixFlash,
  prix,
  colors,
  brand,
  reference,
  stock,
}) {
  useEffect(() => {
  const cards = document.querySelectorAll(".card-anim");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anime({
            targets: entry.target,
            opacity: [0, 1],
            translateY: [40, 0],
            easing: "easeOutExpo",
            duration: 700,
          });

          observer.unobserve(entry.target); // ne rejoue pas après
        }
      });
    },
    {
      threshold: 0.2, // la carte s'anime quand 20% est visible
    }
  );

  cards.forEach((card) => {
    observer.observe(card);
  });

  return () => observer.disconnect();
}, []);

  const categoriee = article.split("-")[0];
  const articleName = article.split("-")[1];
  const articlImg = article.replace(/-/g, " ");

  const [couleurSelectionnee, setCouleurSelectionnee] = useState(null);
  const [added, setAdded] = useState(false);

  let imagePath = "";
  let productLink = "";

  if (subSubcategorie) {
    imagePath = `${famille}/${categorie}/${subcategorie}/${subSubcategorie}/${articlImg}`;
    productLink = `/produit/${famille}/${categorie}/${subcategorie}/${subSubcategorie}/${articleName}`;
  } else if (subcategorie) {
    imagePath = `${famille}/${categorie}/${subcategorie}/${articlImg}`;
    productLink = `/produit/${famille}/${categorie}/${subcategorie}/${articleName}`;
  } else {
    imagePath = `${famille}/${categoriee}/${articlImg}`;
    productLink = `/produit/${famille}/${categoriee}/${articleName}`;
  }

  const imageUrl = `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(
    imagePath
  )}.jpeg?alt=media`;

  // --- ajout au panier ---
  const addToCart = () => {
    if (stock <= 0) return;

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    let productExists = false;

    existingCart.forEach((product) => {
      if (product.name === articleName && product.color === couleurSelectionnee) {
        productExists = true;
        product.quantite += 1;
      }
    });

    if (!productExists) {
      let price = prixPromo ? prixPromo : prixFlash ? prixFlash : prix;
      const product = {
        family: famille,
        name: articleName,
        img: articlImg,
        categorie,
        souscategorie: subcategorie,
        soussouscategorie: subSubcategorie,
        price: price.toFixed(3),
        brand,
        reference,
        quantite: 1,
        color: couleurSelectionnee,
      };
      existingCart.push(product);
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    setAdded(true);

    // 🚀 Met à jour le badge du Header instantanément
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const discountPercent = prixPromo ? ((prix - prixPromo) / prix) * 100 : 0;

  return (
    <div className="product-card card-anim">

      
      {discountPercent > 0 && <div className="badge promo">-{discountPercent.toFixed(0)}%</div>}
      {/*stock > 0 && <div className="badge new">Nouveau</div>*/}

      <a className="cardMediaLink" href={productLink}>
        <img src={imageUrl} alt={articleName} className="product-img" />
      </a>

      <div className="info">

        <h3 className="title">{articleName}</h3>
        <p className="desc">{brand}</p>

        <div className="price">
          {prixFlash ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixFlash.toFixed(3)} TND</span>
            </>
          ) : prixPromo ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixPromo.toFixed(3)} TND</span>
            </>
          ) : (
            <span className="new-price">{prix.toFixed(3)} TND</span>
          )}
        </div>

        {colors && colors.length > 0 && (
          <div className="colors-container">
            {colors.map((color, i) => (
              <img
                key={i}
                src={require(`../../images/colors/${color}.jpeg`)}
                alt={color}
                className={`color-circle ${color === couleurSelectionnee ? "selected" : ""}`}
                onClick={() => setCouleurSelectionnee(color)}
              />
            ))}
          </div>
        )}

        <button
          className={`add-cart-btn ${stock <= 0 ? "disabled" : ""}`}
          onClick={addToCart}
          disabled={stock <= 0}
        >
         
          <span>{added ? "Ajouté !" : "Ajouter au panier"}</span>
          {added ?(<></>) :(<ShoppingCartIcon style={{ fontSize: 20 }} />)}
        </button>

        {stock <= 0 && <p className="out-stock">En arrivage</p>}
      </div>
    </div>
  );
}
